module.exports = __webpack_public_path__ + "img/dream-journal_B095GLRS9L.b5f90851.jpg";